import { render } from "./InfoText.vue?vue&type=template&id=60f3b658&scoped=true"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"

import "./InfoText.vue?vue&type=style&index=0&id=60f3b658&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f3b658"]])

export default __exports__